import { render, staticRenderFns } from "./SelectWorkTypes.vue?vue&type=template&id=065dce38&scoped=true"
import script from "./SelectWorkTypes.vue?vue&type=script&lang=js"
export * from "./SelectWorkTypes.vue?vue&type=script&lang=js"
import style0 from "./SelectWorkTypes.vue?vue&type=style&index=0&id=065dce38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065dce38",
  null
  
)

export default component.exports